// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"31d6cfe0","183":"48ecf74e","320":"e71d9ca6","435":"31d6cfe0","944":"a7f05105"}[chunkId] + ".chunk.css";
};